import {
  ActionIcon,
  Box,
  Flex,
  Group,
  Stack,
  Text,
  Textarea,
  Tooltip,
} from "@mantine/core";
import { useState } from "react";
import { IconX } from "@tabler/icons";
import { useHover } from "@mantine/hooks";
import { Tag } from "../../Tags-old/Tag";
import { IdeaTagsByCategory } from "../../Tags-old/IdeaTagsByCategory";
import { useIdeaPage } from "../../../hooks/ideaPage";
import {useFields} from "../../../hooks/useFields";
import { useUserPermissions } from "../../../hooks/useUserPermissions";
const OverView = ({
  reviewMode,
  setReviewMode,
  description,
  setDescription,
  updateIdeaDescription,
  longDescriptionCheck,
  idea,
  ideaId,
}: {
  reviewMode: boolean;
  setReviewMode: any;
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
  updateIdeaDescription: any;
  longDescriptionCheck: any;
  idea: any;
  ideaId: string;
}) => {
  const { hovered, ref } = useHover();
  const [editing, setEditing] = useState(false);

  const { addedAttributes } = useFields();
  const { idea: ideaData } = useIdeaPage()
  const { canEditIdeas } = useUserPermissions();  
  
  // Compute derived values from idea object
  const isGenerated = ideaData?.state === 'generated';
  const isReadOnly = isGenerated || !canEditIdeas;

  return (
    <Box
      mah="386px"
      pt={16}
      pl={24}
      pr={24}
      pb={24}
      bg={"#ffffff"}
      sx={{ 
        borderBottom: "1px solid #D8D8DB",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Flex justify="space-between" ml={4} mb={12} sx={{ flexShrink: 0 }}>
        <Box>
          <Text color="#212529" fw={600}>
            Description
          </Text>
        </Box>
        <Flex
          sx={{ cursor: "pointer" }}
          onClick={() => setReviewMode(!reviewMode)}
        >
          <IconX size={16} color="#5C5CEB" />
          <Text ml="3px" color="#5C5CEB">
            Close
          </Text>
        </Flex>
      </Flex>
      
      <Box sx={{ 
        flex: 1, 
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        minHeight: 0
      }}>
        <Stack sx={{ flexShrink: 0 }}>
          {!isReadOnly && addedAttributes.some((attr: any) =>
            attr.fieldPath === "tags" || !!attr.category
          ) && (
            <IdeaTagsByCategory idea={idea} showAddBtn isReadOnly={isReadOnly} />
          )}
        </Stack>
        
        <Tooltip label="Edit description" disabled={editing || isReadOnly}>
          <Box ref={ref} sx={{ flex: 1, minHeight: 0 }}>
            <Textarea
              autosize
              onClick={() => {
                if (!editing && !isReadOnly) {
                  setEditing(true);
                }
              }}
              placeholder="Enter description"
              minRows={2}
              value={description}
              onChange={(event) => {
                if(!isReadOnly){
                  setDescription(event.currentTarget.value);
                }
                
                /* longDescriptionCheck() */
              }}
              onBlur={(event) => {
                longDescriptionCheck();
                updateIdeaDescription(event.currentTarget.value);
                setEditing(false);
              }}
              sx={{
                cursor: isReadOnly ? "not-allowed" : "text", // Disable cursor if `isReadOnly` is true
                whiteSpace: "pre-line",
                height: "100%"
              }}
              styles={() => ({
                wrapper: {
                  height: "100%",
                  borderRadius: "6px",
                },
                root: {
                  height: "100%",
                  border: (editing && !isReadOnly)
                    ? "1.6px solid rgba(92, 92, 235, 0.3)"
                    : (hovered && !isReadOnly)
                      ? "1.6px solid #D8D8DB"
                      : "1.6px solid transparent",
                  borderRadius: "6px",
                },
                input: {
                  cursor: isReadOnly ? "default" : "text",
                  border: "none",
                  width: "100%",
                  height: "100%",
                  minHeight: "80px",
                  maxHeight: "none",
                  fontSize: "14px",
                  backgroundColor: (hovered && ! isReadOnly) ? "#F8F9FA" : "#fff",
                  margin: "0px",
                  padding: "4px",
                  whiteSpace: "pre-line",
                  overflow: "auto",
                  resize: "none"
                },
              })}
              
            />
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default OverView;
